import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AlertService } from '../alert/alert.service';
import { AlertType } from '../alert/alert.interface';
import { AttachmentUtil } from '../utils/attachment.utils';
import { Attachment } from '../http/attachments/attachments.interface';

@Injectable({
  providedIn: 'root'
})
export class DownloadFileService {
  constructor(
    private http: HttpClient,
    private readonly alertService: AlertService,
    private httpClient: HttpClient
  ) { }

  getFileNewWindow(url: string, filename: string): void {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    });

    this.http.get(url, { headers, responseType: 'blob' }).subscribe({
      next: (response: Blob) => {
        const fileExtension = filename.split('.').pop()?.toLowerCase();
        const newWindow = window.open();
        if (newWindow) {
          const reader = new FileReader();
          reader.onload = () => {
            if (fileExtension === 'pdf') {
              // reader.result is a base64 string show in new window
              newWindow.document.title = 'Documento';
              newWindow.document.body.innerHTML = `
                <iframe type="application/pdf" width="100%" height="100%" 
                  src="${reader.result}" frameborder="0"></iframe>`;
            } else if (['png', 'jpg', 'jpeg'].includes(fileExtension!)) {
              // Mostrar imágenes en una nueva pestaña
              newWindow.document.title = 'Imagen';
              newWindow.document.body.innerHTML = `
                <img src="${reader.result}" 
                  style="width: 100%; height: 100%; object-fit: contain;" alt="Imagen" />`;
            } else {
              // Descargar otros archivos
              const blobUrl = window.URL.createObjectURL(response);
              const a = document.createElement('a');
              a.href = blobUrl;
              a.download = filename;
              a.click();
              window.URL.revokeObjectURL(blobUrl);
              newWindow.close(); // Cierra la pestaña si no se usa para mostrar el archivo
            }
          };

          reader.onerror = (error) => {
            console.error('Error al leer el archivo', error);
            newWindow.close(); // Cierra la pestaña en caso de error
          };

          reader.readAsDataURL(response); // Convierte el Blob a base64 para imágenes o PDFs
        }
      },
      error: (error) => {
        this.alertService.setAlert({
          message: $localize`:@@DownloadFiles.ErrorFileNewWindow:No se ha podido descargar el fichero.`,
          type: AlertType.Error,
          dismissible: true,
          dismissOnTimeout: 2000
        });
        console.error('Error al descargar el archivo', error);
      }
    });
  }

  getAttachementNewWindow(url: string): void {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + sessionStorage.getItem('token')
    });

    // url return Attachment interface
    this.httpClient.get<Attachment>(url, { headers }).subscribe({
      next: (attachment: Attachment) => {
        const filename = attachment.name;
        const fileExtension = filename.split('.').pop()?.toLowerCase();
        
        if (fileExtension === 'pdf' && attachment.data) {
          // Convertir Base64 a Blob
          const byteCharacters = atob(attachment.data); // Decodificar Base64
          const byteNumbers = new Uint8Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const blob = new Blob([byteNumbers], { type: 'application/pdf' });

          // Crear un objeto URL y abrir el PDF
          const fileURL = URL.createObjectURL(blob);
          window.open(fileURL, '_blank');
        } else if (['png', 'jpg', 'jpeg'].includes(fileExtension!) && attachment.data) {
          // Mostrar imágenes en una nueva pestaña
          const blob = new Blob([attachment.data], { type: attachment.mime });
          const blobUrl = window.URL.createObjectURL(blob);
          const newWindow = window.open();
          if (newWindow) {
            newWindow.document.title = 'Imagen';
            newWindow.document.body.innerHTML = `
              <img src="${blobUrl}" 
                style="width: 100%; height: 100%; object-fit: contain;" alt="Imagen" />`;
          }
        } else if (attachment.data) {
          // Descargar otros archivos
          const blob = new Blob([attachment.data], { type: attachment.mime });
          const blobUrl = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        }
      }, error: (error) => {
        this.alertService.setAlert({
          message: $localize`:@@DownloadFiles.ErrorFileNewWindow:No se ha podido descargar el fichero.`,
          type: AlertType.Error,
          dismissible: true,
          dismissOnTimeout: 2000
        });
        console.error('Error al descargar el archivo', error);
      }
    });
  }
}
